import React from "react"
import { InputContainer, LabelRow, Label, FieldText, FormRow } from "./common"
import { Dropdown } from "buoy-core"
import { nDashPlaceholder } from "../userDetailsUtilities"
import { ToolTip } from "../CardSubSection"

const Race = ({ questions, dirty, setPredispositionAnswer }) => (
  <React.Fragment>
    {questions &&
      questions.map((q, i) => (
        <FormRow isEditing={dirty} key={q.token}>
          <InputContainer>
            <LabelRow>
              <Label>Race</Label>
              {dirty && <ToolTip message={q.tooltip} />}
            </LabelRow>
            {dirty ? (
              <Dropdown
                options={Object.keys(q.options)
                  .sort((a, b) => q.options[a].order > q.options[b].order)
                  .map(k => ({
                    text: q.options[k].text,
                    value: q.options[k].token,
                  }))}
                placeholder="Select race"
                value={q.answer}
                onChange={setPredispositionAnswer(i)}
              />
            ) : (
              <FieldText small>
                {(q.answer && q.options[q.answer].text) || nDashPlaceholder}
              </FieldText>
            )}
          </InputContainer>
        </FormRow>
      ))}
  </React.Fragment>
)

export { Race as default }



// WEBPACK FOOTER //
// ./assets/account/components/forms/Race.js